// extracted by mini-css-extract-plugin
export default {"hoverCursor":"hoverCursor__13NOv","hoverPointer":"hoverPointer__LJ6zT"};